var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#FC39FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4477 10.3515C24.9164 10.8202 24.9164 11.5813 24.4477 12.05L14.8492 21.6485C14.3806 22.1172 13.6194 22.1172 13.1508 21.6485L8.35151 16.8492C7.88283 16.3806 7.88283 15.6194 8.35151 15.1508C8.82018 14.6821 9.58131 14.6821 10.05 15.1508L14.0019 19.0989L22.753 10.3515C23.2217 9.88283 23.9828 9.88283 24.4515 10.3515H24.4477Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkCheck);
export default __webpack_public_path__ + "static/media/pink-check.7b01b271b7cf4c72f86890b333242843.svg";
export { ForwardRef as ReactComponent };